import React from 'react';
import { Modal } from 'react-bootstrap';

const ModalComponent = ({ show, handleClose, title, bodyContent, size = 'lg' }) => {
  return (
    <Modal show={show} onHide={handleClose} size={size} centered>
      {/* Always render the header so the close button is visible */}
      <Modal.Header closeButton>
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>

      <Modal.Body>
        {bodyContent}
      </Modal.Body>
    </Modal>
  );
};

export default ModalComponent;
